import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { blockUnblockFormSchema } from './block-unblock-form.schema';

export const useBlockUnblockForm = () => {
  return useForm({
    resolver: yupResolver(blockUnblockFormSchema),
    defaultValues: blockUnblockFormSchema.cast({}),
  });
};
